import React from 'react';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import { MenuItem } from '../menuItem';

interface Props {
  isActive: boolean;
}

const InvoiceBadge: React.FC<Props> = ({ isActive }) => {
  const { invoiceStore } = rootStore;
  const { invoices } = invoiceStore || {};
  const invoiceCount = invoices?.filter((item) => item?.statusText !== 'PAID').length;

  return (
    <MenuItem path='/invoices' isActive={isActive} iconName='invoice-icon' label='Invoices' count={invoiceCount} />
  );
};

export default observer(InvoiceBadge);
